export interface CompanySelectorItem {
  uuid: string;
  name: string;
}

export interface AgencyResponse {
  uuid: string;
  name: string;
  companies: CompanySelectorItem[];
}

export const useAgencyStore = defineStore('agency', () => {
  const { $sellebrate } = useNuxtApp();

  const agency = ref<AgencyResponse | null>(null);
  const isLoadingAgency = ref(false);

  const hasAgencyAccess = computed(() => agency.value !== null);

  const fetchAgency = async () => {
    if (isLoadingAgency.value) return;

    isLoadingAgency.value = true;
    try {
      const response = await $sellebrate<AgencyResponse | null>('/company/agency/');
      agency.value = response;
    }
    catch (error) {
      console.error('Failed to fetch agency information:', error);
      agency.value = null;
    }
    finally {
      isLoadingAgency.value = false;
    }
  };

  const switchCompany = async (companyId: string) => {
    if (!agency.value) return;

    await $sellebrate('/company/agency/switch-company', {
      method: 'POST',
      params: { company_id: companyId },
    });
  };

  return {
    agency,
    fetchAgency,
    switchCompany,
    isLoadingAgency,
    hasAgencyAccess,
  };
});
